var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCheckCircleGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_192_7279",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666656,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_192_7279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73333 9.69999L6.3 8.26666C6.17778 8.14444 6.02222 8.08333 5.83333 8.08333C5.64444 8.08333 5.48889 8.14444 5.36667 8.26666C5.24444 8.38888 5.18333 8.54444 5.18333 8.73333C5.18333 8.92222 5.24444 9.07777 5.36667 9.19999L7.26667 11.1C7.4 11.2333 7.55556 11.3 7.73333 11.3C7.91111 11.3 8.06667 11.2333 8.2 11.1L11.9667 7.33333C12.0889 7.21111 12.15 7.05555 12.15 6.86666C12.15 6.67777 12.0889 6.52222 11.9667 6.39999C11.8444 6.27777 11.6889 6.21666 11.5 6.21666C11.3111 6.21666 11.1556 6.27777 11.0333 6.39999L7.73333 9.69999ZM8.66667 15.1667C7.74444 15.1667 6.87778 14.9917 6.06667 14.6417C5.25556 14.2917 4.55 13.8167 3.95 13.2167C3.35 12.6167 2.875 11.9111 2.525 11.1C2.175 10.2889 2 9.42222 2 8.49999C2 7.57777 2.175 6.71111 2.525 5.89999C2.875 5.08888 3.35 4.38333 3.95 3.78333C4.55 3.18333 5.25556 2.70833 6.06667 2.35833C6.87778 2.00833 7.74444 1.83333 8.66667 1.83333C9.58889 1.83333 10.4556 2.00833 11.2667 2.35833C12.0778 2.70833 12.7833 3.18333 13.3833 3.78333C13.9833 4.38333 14.4583 5.08888 14.8083 5.89999C15.1583 6.71111 15.3333 7.57777 15.3333 8.49999C15.3333 9.42222 15.1583 10.2889 14.8083 11.1C14.4583 11.9111 13.9833 12.6167 13.3833 13.2167C12.7833 13.8167 12.0778 14.2917 11.2667 14.6417C10.4556 14.9917 9.58889 15.1667 8.66667 15.1667Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGrey);
export default __webpack_public_path__ + "static/media/check_circle_grey.d43278422f44dbd061295e64ed34e64e.svg";
export { ForwardRef as ReactComponent };